// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePageSlideWrapper_container__116Km","img":"HomePageSlideWrapper_img__3HGny","wrapperleft":"HomePageSlideWrapper_wrapperleft__2mWrV"};